/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 17:16:13 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';
import { linkButton } from 'styles';

const LinkButton = ({
  basePath,
  name,
  pathname,
  state,
  icon,
  addLabel,
  noStyles = false,
  ...rest
}) => {
  const classes = linkButton();
  return (
    <Button
      className={noStyles ? classes.none : classes.root}
      component={Link}
      to={{
        pathname,
        state,
      }}
      label={name}
      {...rest}
    >
      {icon}
    </Button>
  );
};

LinkButton.defaultProps = { addLabel: false };

export default LinkButton;
